import React, { useState } from 'react'
import { arrayOf, object, number } from 'prop-types'

import BaseTemplate from 'components/templates/BaseTemplate'

import Container from 'components/atoms/Container'
import Row from 'components/atoms/Row'
import Col from 'components/atoms/Col'
import Button from 'components/atoms/Button'
import Typography from 'components/atoms/Typography'
import { Image } from 'components/qstrap'

import AptitudeBanner from 'components/organisms/AptitudeBanner'
import CampusPerfectCard from 'components/organisms/CampusPerfectCard'

import { branch } from 'baobab-react/higher-order'
import API from 'utils/API'
import storage from 'utils/storage'

const Partners = ({ partners, page, perPage, partnersCount }) => {
  const [loading, setLoading] = useState(false)

  const fetchPartners = () => {
    setLoading(true)
    setTimeout(() => {
      API.get('/partners.json', {
        page: page + 1,
        per_page: perPage,
      })
      .then(({ data }) => {
        const serverProps = storage.select('serverProps')
        const updatedData = {
          page: data.params.page,
          perPage: data.params.perPage,
          partners: [...partners, ...data.partners],
        }
        serverProps.merge(updatedData)
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
    }, 500)
  }

  return (
    <BaseTemplate useNewHeader>
      <div className="partners-page">
        <AptitudeBanner/>
        <Container>
          <Typography component="h1" variant="title">
            Daftar Mitra Quipper Campus
          </Typography>
          <div className={`${!loading && 'hide'} card-loader`}>
            <Image src="/assets/img/loader.gif" />
          </div>
          <div className="partners-page__list">
            <Row>
              {
                partners.map((partner, idx) => (
                  <Col md="4" key={`partner-itm-${partner.id}`}>
                    <CampusPerfectCard
                      dataTestId={`dir-mitra-card-${idx}`}
                      kind="partners"
                      description={partner.description}
                      href={partner.action === 'url' ? partner.actionUrl : partner.brochure}
                      leadUrl={API.endPoints({ id: partner.id }).leads.partner}
                      leadSource="partner"
                      leadSourceDetail={{
                        organization_type: partner.organization_type,
                        organization_reference: partner.organization_reference,
                        school_id: partner.school_id,
                      }}
                      title={partner.name}
                      thumbnail={partner.image}
                      linkRel={partner.action !== 'url' ? 'nofollow' : undefined}
                      recordLead={partner.record_lead}
                    />
                  </Col>
                ))
              }
            </Row>
            {
              partners.length !== partnersCount &&
              <div className="partners-page__pagination">
                <Button component="button" variant="link" onClick={fetchPartners}>Lihat Mitra Lainnya</Button>
              </div>
            }
          </div>
        </Container>
      </div>
      <style jsx>
        {`
          .partners-page {
            :global(h1) {
              margin-top: 32px;
            }
            :global(.campus-perfect-card) {
              height: 321px;
            }
            :global(.campus-perfect-card__identity) {
              height: 48px;
            }
            &__list {
              margin-top: 24px;
              margin-bottom: 32px;
            }
            &__pagination {
              display: flex;
              justify-content: center;
              :global(button) {
                color: #7d92a9;
                background-color: transparent;
                border: none;
                font-weight: bold;
                font-size: 16px;
              }
            }
          }
        `}
      </style>
    </BaseTemplate>
  )
}

Partners.propTypes = {
  partners: arrayOf(object),
  page: number,
  perPage: number,
  partnersCount: number,
}

Partners.defaultProps = {
  partners: [],
  page: 1,
  perPage: 12,
}

export { Partners }

export default branch({
  partners: ['serverProps', 'partners'],
  page: ['serverProps', 'page'],
  perPage: ['serverProps', 'perPage'],
  partnersCount: ['serverProps', 'partnersCount'],
}, Partners)
